<br>
<div class="card card-default">
    <div class="card-header title_size">
    <h2 class="card-title">Edit Customer Details</h2>
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    
    <div class="card-body">

    <div class="row">
    <div class="col-md-6">

         <div class="form-group">
            <label>Customer Name</label>
            <input type="text"  class="form-control" [(ngModel)]="data.customer_name">
        </div>

        <div class="form-group">
        <label>Customer Code</label>
        <input type="text" class="form-control" class="form-control" [(ngModel)]="data.customer_code">
        </div>
        <div class="form-group">
            <label>Department</label>
            <!--
                <select  #teams (change)="onSelected(teams.value)" class="form-control select2 select2-hidden-accessible" style="width: 100%;" data-select2-id="1" tabindex="-1" aria-hidden="true"  [(ngModel)]="data.customer_department">
            -->
                <select  #teams class="form-control select2 select2-hidden-accessible" style="width: 100%;" data-select2-id="1" tabindex="-1" aria-hidden="true"  [(ngModel)]="data.customer_department" (ngModelChange)="onSelected(teams.value)" >
                <option selected="selected" data-select2-id="1">{{data.customer_department}}</option>
                <option *ngFor="let d of department" data-select2-id="2" [value]="d.department_id">{{d.department_name}}</option>
                <span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>
                </select> 
        </div>
        <!--------------------------------------------------------------------------------------->
        <div class="form-group">
            <label>Responsible Employee</label>
            <select  #teams1 (change)="onSelectedEmployee1(teams1.value)" class="form-control select2 select2-hidden-accessible" style="width: 100%;" data-select2-id="1" tabindex="-1" aria-hidden="true"  [(ngModel)]="data.responsible_name">
                <option selected="selected" data-select2-id="1">{{data.responsible_name}}</option>
                <option *ngFor="let d of employee" data-select2-id="2" [value]="d.employee_id">{{d.employee_name}}</option>
                
                </select> 
        </div>
        <div class="form-group">
            <label>Second Responsible</label>
            <select  #teams2 (change)="onSelectedEmployee2(teams2.value)" class="form-control select2 select2-hidden-accessible" style="width: 100%;" data-select2-id="1" tabindex="-1" aria-hidden="true"  [(ngModel)]="data. second_responsible_name">
                <option selected="selected" data-select2-id="1">{{data. second_responsible_name}}</option>
                <option *ngFor="let d of employee" data-select2-id="2" [value]="d.employee_id">{{d.employee_name}}</option>
                </select> 
        </div>
        <div class="form-group">
            <label>Sales Eecutive Name</label>
            <select  #teams3 (change)="onSelectedEmployee3(teams3.value)" class="form-control select2 select2-hidden-accessible" style="width: 100%;" data-select2-id="1" tabindex="-1" aria-hidden="true"  [(ngModel)]="data.sales_executive_name">
                <option selected="selected" data-select2-id="1">{{data.sales_executive_name}}</option>
                <option *ngFor="let d of employee" data-select2-id="2" [value]="d.employee_id">{{d.employee_name}}</option>
                </select> 
        </div>
        <!--------------------------------------------------------------------------------------->


        <div class="form-group">
            <label>Credit Balance</label>
            <input type="number" class="form-control" [(ngModel)]="data.credit_balance">
        </div>
        <div class="form-group">
            <label>Oldest Due Sales Date</label>
            <input type="date" class="form-control" [(ngModel)]="data.oldest_due_inv_date">
        </div>
        <div class="form-group">
            <label>Contract</label>
            <input type="text" class="form-control" [(ngModel)]="data.contract">
        </div>
        

        </div>
        
        <div class="col-md-6">
       
       

            <div class="form-group">
                <label>Email</label><span class="error">{{EmailAlert}}</span>
                <input type="email" class="form-control" [(ngModel)]="data.customer_email" [formControl]="email" (ngModelChange)="valuechange1($event)">
            </div>
      
            <div class="form-group">
                <label>Credit Limit</label>
                <input type="number" class="form-control" [(ngModel)]="data.credit_limit">
            </div>
    
            <div class="form-group">
                <label>Oldest Due Inv Number</label>
                <input type="text" class="form-control" [(ngModel)]="data.oldest_due_inv_number">
            </div>
       
            <div class="form-group">
                <label>Company Price</label>
                <input type="text" class="form-control" [(ngModel)]="data.company_price">
            </div>
       
    
         <div class="form-group">
            <label>This month Sale</label>
            <input type="text" [readonly]="true" class="form-control" [(ngModel)]="data.current_month_sales">
            
        </div>

        <div class="form-group">
            <label>Last 3 month sales</label>
            <input type="text" [readonly]="true" class="form-control" [(ngModel)]="data.last_3_month_sales">
        </div>
        <div class="form-group">
                <label>Earliest Overdue</label>
                <input type="date" class="form-control" [(ngModel)]="data.earliest_overdue_date">  
        </div>
        <div class="form-group">
            <label>Payment Terms</label>
            <input type="text" class="form-control" [(ngModel)]="data.payment_terms">
        </div>


        <div class="form-group">
            <label for="phone_no" class="required">Phone Number</label>
            <div class="d-flex">
                <ng-select required [(ngModel)]="data.customer_country_code" (close)="subInput('close')" (open)="subInput('focus')"
                    (mouseenter)="subInput('focus')" (mouseleave)="subInput('close')"
                    [class]="subinputFocused" 
                    (change)="countryCode($event)">
                    <ng-option *ngFor="let count of country" [value]="count.dial_code">
                        <img [src]="'assets/country flag icon/' + count.code + '.svg?'+count.name"
                            width="30px">
                        {{count.dial_code}}
                    </ng-option>
                </ng-select>
                <input type="text" [(ngModel)]="this.data.customer_mobile" (ngModelChange)="mobileNumbercustomer($event)" id="phone_no"
                    class="form-control generic-input-main" [class]="subinputFocusedmain"
                    name=phone_no style="text-transform: capitalize;">
            </div>
            <p class="text-danger">{{codeValid}}</p>
       
        </div>



      
    </div>
</div>
        
<div class="alert alert-success alert-dismissible alertWidth" *ngIf="isShown">
    <button type="button" class="close" data-dismiss="alert" aria-hidden="true" (click)="shown()">×</button>
    <h4><i class="icon fas fa-check"></i> {{alert}}</h4>    
</div>
   
         
       <!----
          <div class="sucess" *ngIf="isShown">
            <span class="closebtn content" onclick="this.parentElement.style.display='none';">&times;</span> 
            {{alert}}
          </div><br>
------>
        <button type="submit" class="btn btn-primary btn_allign" (click)="btnClick();">Submit</button>
   
        
</div>
